import SectionHeader from "../components/SectionHeader";
import SEO from "../components/SEO";
import { CAREERS, BRAND } from "../lib/content";
import { ArrowUpRight } from "lucide-react";

export default function CareersPage() {
  return (
    <main data-testid="page-careers">
      <SEO
        path="/careers"
        image="/brand/og-careers.jpg"
        title="Careers"
        description="Join Logarithmic Technologies. Open roles in mechanical engineering, drive systems, and program management as we scale a step-function speed reducer technology with defense and propulsion partners."
      />
      <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 border-b border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <SectionHeader
            kicker="/ careers"
            title={<>Small team.<br />Hard problems.</>}
            lead="We're hiring engineers and operators who want to put the first practical
reducer of a generation into propulsion systems that matter."
          />
        </div>
      </section>

      <section className="relative py-16 md:py-24">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <ul className="divide-y divide-white/10 border-y border-white/10">
            {CAREERS.map((c, i) => (
              <li key={c.title} data-testid={`career-item-${i}`} className="py-8 md:py-10 grid md:grid-cols-12 gap-6 items-start hover:bg-[#0a0a0a] transition-colors">
                <div className="md:col-span-2 font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
                  ROLE / 0{i + 1}
                </div>
                <div className="md:col-span-7">
                  <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">{c.title}</h3>
                  <p className="mt-2 text-white/70 leading-relaxed max-w-2xl">{c.summary}</p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    <span className="font-mono-tech text-[10px] uppercase tracking-widest text-white/60 border border-white/15 px-2 py-1">
                      {c.location}
                    </span>
                    <span className="font-mono-tech text-[10px] uppercase tracking-widest text-white/60 border border-white/15 px-2 py-1">
                      {c.type}
                    </span>
                  </div>
                </div>
                <div className="md:col-span-3 md:text-right">
                  <a
                    href={`mailto:${BRAND.contactEmail}?subject=${encodeURIComponent("Application: " + c.title)}`}
                    data-testid={`career-apply-${i}`}
                    className="inline-flex items-center gap-2 border border-white/20 hover:border-white px-5 py-3 font-mono-tech uppercase tracking-widest text-[11px]"
                  >
                    Apply <ArrowUpRight size={14} />
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="relative py-20 md:py-24 bg-[#0a0a0a] border-t border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">/ culture</div>
            <h2 className="mt-4 font-display font-black text-3xl md:text-5xl tracking-tighter leading-[0.95]">
              Engineering-led. Program-disciplined.
            </h2>
          </div>
          <div className="md:col-span-7 text-white/70 leading-relaxed space-y-4">
            <p>
              We run the company like a good program team: clear milestones, short
              decision loops, and engineering owning the product. No sprint theater,
              no slide deck commitments — if you build it, you can defend it.
            </p>
            <p>
              Clearance-eligible roles are noted; we sponsor clearance processes where
              needed for qualified candidates.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
